import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { FactoryNavigationBar } from '../component/navigation-bar/FactoryNavigationBar';
import { GeneratePasswordsDiv } from '../component/generate-password/GeneratePasswordsDiv';

export const GeneratePasswordsPage = () => (
  <MainPageLayout
    navigationBar={<FactoryNavigationBar />}
    elementCentr={<GeneratePasswordsDiv />}
  />
);
